module.exports = __webpack_public_path__ + "img/martial-arts-uniform.cf1355f0.png";